import { render, staticRenderFns } from "./AdminController.vue?vue&type=template&id=70789fc0"
import script from "./AdminController.vue?vue&type=script&lang=js"
export * from "./AdminController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports